import { StudyStatus } from "healthex-common/study.dtos";
import { asEnum, willNeverHappen } from "healthex-common/utils";
import { getObservableT } from "../Infra/i18next";
import { colors } from "healthex-common/colors";
const t = getObservableT("common");
export var StudyStatusUI;
(function (StudyStatusUI) {
    StudyStatusUI["DRAFT"] = "DRAFT";
    StudyStatusUI["ACTIVE"] = "ACTIVE";
    StudyStatusUI["COMPLETED"] = "COMPLETED";
    StudyStatusUI["WITHDRAWN"] = "WITHDRAWN";
    StudyStatusUI["PAUSED"] = "PAUSED";
})(StudyStatusUI || (StudyStatusUI = {}));
export function getStudyStatusDescription(value) {
    const status = typeof value === "object" ? getStudyStatusUI(value) : value;
    switch (status) {
        case StudyStatusUI.DRAFT:
            return t("Draft");
        case StudyStatusUI.ACTIVE:
            return t("Active");
        case StudyStatusUI.COMPLETED:
            return t("Completed");
        case StudyStatusUI.WITHDRAWN:
            return t("Withdrawn");
        case StudyStatusUI.PAUSED:
            return t("Paused");
    }
    return willNeverHappen(status);
}
export function getStudyStatusLabel(value) {
    const status = typeof value === "object" ? getStudyStatusUI(value) : value;
    switch (status) {
        case StudyStatusUI.DRAFT:
            return "Draft";
        case StudyStatusUI.ACTIVE:
            return "Active";
        case StudyStatusUI.COMPLETED:
            return "Completed";
        case StudyStatusUI.WITHDRAWN:
            return "Withdrawn";
        case StudyStatusUI.PAUSED:
            return "Paused";
    }
    return willNeverHappen(status);
}
export function getStudyStatusColor(value) {
    const status = typeof value === "object" ? getStudyStatusUI(value) : value;
    switch (status) {
        case StudyStatusUI.COMPLETED:
            return colors.forest_8;
        case StudyStatusUI.WITHDRAWN:
            return colors.tulip_8;
        default:
            return colors.black_8;
    }
}
export function getStudyStatusUI(study) {
    var _a;
    if (study.status === StudyStatus.ACTIVE && study.paused)
        return StudyStatusUI.PAUSED;
    return (_a = asEnum(StudyStatusUI)(study.status)) !== null && _a !== void 0 ? _a : StudyStatusUI.DRAFT;
}
export function getFilterFromStudyStatusUI(status) {
    var _a;
    if (status === StudyStatusUI.PAUSED)
        return { statuses: [StudyStatus.ACTIVE], paused: true };
    return { statuses: [(_a = asEnum(StudyStatus)(status)) !== null && _a !== void 0 ? _a : StudyStatus.DRAFT], paused: false };
}
